import MessageApi from '../../../../api/inbox/message';
import ConversationApi from '../../../../api/inbox/conversation';
import types from '../../../mutation-types';

export default {
  async translateMessage(_, { conversationId, messageId, targetLanguage }) {
    await MessageApi.translateMessage(
      conversationId,
      messageId,
      targetLanguage
    );
  },

  // Translated content arrives over the websocket as a message.updated event,
  // so this only has to return the pagination cursor for "translate more".
  async bulkTranslateMessages(
    _,
    { conversationId, targetLanguage, limit, beforeMessageId }
  ) {
    const {
      data: { meta },
    } = await MessageApi.bulkTranslate({
      conversationId,
      targetLanguage,
      limit,
      beforeMessageId,
    });

    return {
      beforeMessageId: meta.before_message_id,
      hasMore: meta.has_more,
    };
  },

  async previewReplyTranslation(_, { conversationId, content, targetLanguage }) {
    const { data } = await MessageApi.translationPreview({
      conversationId,
      content,
      targetLanguage,
    });
    return data;
  },

  async updateTranslationSettings(
    { commit },
    { conversationId, conversationLanguage, autoTranslateOutgoing }
  ) {
    const {
      data: { additional_attributes: additionalAttributes },
    } = await ConversationApi.updateTranslationSettings({
      conversationId,
      conversationLanguage,
      autoTranslateOutgoing,
    });

    commit(types.UPDATE_CONVERSATION_ADDITIONAL_ATTRIBUTES, {
      conversationId,
      additionalAttributes,
    });
  },
};
